import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from './View'
import Button from './Button'

const useStyles = createUseStyles(theme => ({
  root: {
    margin: '0 36px 32px',
    flexDirection: 'column',
  },
  logo: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    '@media(min-width: 1000px)': {
      display: 'none'
    }
  },
  img: {
    width:'75%',
    maxWidth: '150px',
    marginTop: '20px',
    objectFit: 'contain'
  },
  space: {
    width: '16px'
  }
}))

function Footer (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  
  return (
    <View className={styles.root}>
      <View>
        { props.onBack && 
          <Button
            customStyles={props.backStyles}
            onClick={() => props.onBack()}
            label={props.backLabel || 'Voltar'}
            outline
          />
        }
        { props.onBack && props.onNext && 
          <div className={styles.space}></div>
        }
        
        { props.onNext && 
          <Button 
            customStyles={props.nextStyles}
            label={props.nextLabel || 'Próximo'} 
            onClick={() => props.onNext()}
            disabled={props.disabled}
          />
        }
      </View>
      <div className={styles.logo}>
        { !props.disableLogo && theme.logo && 
          <img 
            className={styles.img} 
            src={theme.logoUrl} 
            alt="Logo"
          />
        }
      </div>
    </View>
  )
}

export default Footer